export default __webpack_public_path__ + "static/10-983d225fda6cde713e6de666833fda51.webp";